<template>
    <div class="wrapper tab-app tab-free">
        <header class="header-with-confetti">
            <span class="new-headline-xlg text-centered">Großartig!<br>Vitadio ist für Sie kostenfrei</span>

            <p class="new-text-lg text-centered text-color-default">Ihre Krankenkasse übernimmt die Kosten für Vitadio vollständig. Jetzt bereiten wir Ihren persönlichen Zugang vor.</p>
        </header>

        <div class="text-wrapper">
            <div>
                <figure>
                    <img src="imgs/web/img_onboarding_screen.png" srcset="imgs/web/img_onboarding_screen.png 1x, imgs/web/img_onboarding_screen@2x.png 2x" alt="">
                </figure>

                <div>
                    <strong class="new-headline-md">Vitadio-App</strong>
                    <span class="new-text-xl">für 0,00 €</span>
                    <p class="new-text-lg text-color-default">Kostenübernahme durch <br> Ihre Krankenkasse</p>
                </div>
            </div>

            <div ref="cta" class="floating-cta">
                <div class="floating-cta-inner" :class="{ 'is-floating': isFloating }">
                    <v-button label="Zugang einrichten" position="center" @onClick="$emit('answer')"></v-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isFloating: false,
                observer: null
            }
        },

        mounted() {
            if (typeof IntersectionObserver === 'undefined') {
                return
            }

            this.observer = new IntersectionObserver(([entry]) => {
                this.isFloating = !entry.isIntersecting
            }, { threshold: 1, rootMargin: '0px 0px -24px 0px' })

            this.observer.observe(this.$refs.cta)
        },

        beforeDestroy() {
            if (this.observer) {
                this.observer.disconnect()
            }
        }
    }
</script>
